import React from 'react'
import Ringing from 'APP/Theme/Sounds/ringing.wav'
import type { DialogueSoundBank, DialogueSoundProps } from './types'

const SoundBank: DialogueSoundBank = {
  ringing: Ringing,
}

/* istanbul ignore next */
const DialogueSound = ({ autoPlay = true, loop = true, name }: DialogueSoundProps) => {
  return (
    <audio autoPlay={autoPlay} loop={loop} style={{ display: 'none' }}>
      <source src={SoundBank[name]} type="audio/wav" />
    </audio>
  )
}

export default DialogueSound
